import type { ReactNode } from "react";

type Props = {
  main: ReactNode;
  gutter?: ReactNode;
  rail?: ReactNode;
  className?: string;
};

/** Shared 3-column feed grid: gutter (140) · main (flex) · rail (36), max 1280px centered. */
export function WaveFeedLayoutRow({
  main,
  gutter,
  rail,
  className = "",
}: Props) {
  return (
    <div className={`wave-feed-grid${className ? ` ${className}` : ""}`}>
      <div className="wave-feed-grid-gutter">{gutter}</div>
      <div className="wave-feed-grid-main">{main}</div>
      <div className="wave-feed-grid-rail">{rail}</div>
    </div>
  );
}
